import { render, staticRenderFns } from "./frontListaRecientes.vue?vue&type=template&id=1bb0ea5b&scoped=true&"
import script from "./frontListaRecientes.vue?vue&type=script&lang=js&"
export * from "./frontListaRecientes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb0ea5b",
  null
  
)

export default component.exports